import React from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'routes'
import PerfectScrollBar from 'react-perfect-scrollbar'

import {
  Button,
  IconButton,
  Box,
  Typography,
  Divider,
  Tooltip,
  makeStyles,
} from '@material-ui/core'

import { Delete as DeleteIcon } from '@material-ui/icons'

import { Permitted } from 'components/Permissions'
import { LogIconButton } from 'components/Logs'
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
} from 'components/Table'
import * as service from 'service'
import DeleteConfirm from '../DeleteConfirm'
import helpers from 'helpers'
import styles from './styles'
import useSnackbar from 'hooks/useSnackbar'
import usePermissions from 'hooks/usePermissions'

const useStyles = makeStyles(styles)

const TableRowEntry = ({ entry, openDialog }) => {
  const classes = useStyles()
  const permissions = usePermissions()

  const canBeDeleted = () => {
    if (
      entry.entryType === 'proportional_reactivation' ||
      entry.entryType === 'proportional_addition' ||
      entry.entryType === 'remaining_credit' ||
      entry.entryType === 'remaining_debit'
    )
      return false

    return true
  }

  return (
    <TableRow>
      <TableCell>{entry.id}</TableCell>
      <TableCell>{entry.typeLabel}</TableCell>
      <TableCell>{entry.description}</TableCell>
      <TableCell align="right" className={classes.priceWidth}>
        {helpers.currency(entry.price)}
      </TableCell>
      {(permissions.isAdmin() || permissions.permitted('destroy_entry')) && (
        <TableCell align="right">
          <LogIconButton
            to={reverse(routes.entries.logs, {
              entryId: entry.id,
            })}
          />

          <Permitted tag="destroy_entry">
            {canBeDeleted() ? (
              <Tooltip title="Excluir">
                <IconButton
                  aria-label="Excluir"
                  onClick={() => {
                    openDialog(entry.id)
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </Permitted>
        </TableCell>
      )}
    </TableRow>
  )
}

const EntriesTable = ({
  contractId,
  contractStatus,
  data,
  onEvent = () => {},
}) => {
  const history = useHistory()
  const snackbar = useSnackbar()
  const permissions = usePermissions()

  const [confirm, setConfirm] = React.useState(false)
  const [entryId, setEntryId] = React.useState()

  const handleCreateEntry = () => {
    history.push(reverse(routes.contracts.entries.new, { contractId }))
  }

  const openDialog = entryId => {
    setConfirm(true)
    setEntryId(entryId)
  }

  const deleteEntry = async (contractId, entryId) => {
    try {
      await service.recurrence.entries.destroy({ contractId, entryId })
      setConfirm(false)

      snackbar.open({
        message: 'Cobrança adicional excluída com sucesso!',
        variant: 'success',
      })

      onEvent()
    } catch (error) {
      snackbar.open({
        message: 'Erro ao excluir cobrança adicional!',
        variant: 'error',
      })
    }
  }

  const entries = helpers.entries.notLaunch(data && data.entries)

  return (
    <>
      <Permitted tag="index_entry">
        <Box
          p={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4">Cobranças adicionais</Typography>
          <Permitted tag="create_entry">
            {contractStatus === 'active' ? (
              <Button
                variant="outlined"
                onClick={handleCreateEntry}
                color="primary"
              >
                Incluir
              </Button>
            ) : null}
          </Permitted>
        </Box>
        <Divider />
        <PerfectScrollBar>
          <Table
            emptyMessage="Não há cobranças adicionas para esta assinatura"
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell>Identificador</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Descrição</TableCell>
                <TableCell align="right">Valor</TableCell>
                {(permissions.isAdmin() ||
                  permissions.permitted('destroy_entry')) && (
                  <TableCell></TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {entries &&
                entries.map(entry => (
                  <TableRowEntry
                    entry={entry}
                    openDialog={openDialog}
                    key={entry.id}
                  />
                ))}
            </TableBody>
          </Table>
        </PerfectScrollBar>
      </Permitted>

      <DeleteConfirm
        confirm={confirm}
        setConfirm={setConfirm}
        entryId={entryId}
        contractId={contractId}
        deleteEntry={deleteEntry}
      ></DeleteConfirm>
    </>
  )
}

export default EntriesTable
